<template>
  <nav class="col-12 pb-0  mb-2">
    <div class="card shadow-lg  card-profile-top">
      <div class="card shadow-lg">
        <div class="card-body p-3">
          <div class="row gx-4">

            <div class="col-auto my-auto">
                <div class="h-100"><h5 class="mb-1">Romaneio de Entrega</h5><p class="mb-0 font-weight-bold text-sm">Pedidos a serem entregues</p>
              </div>
            </div>
            <div class="mx-auto mt-3 col-lg-7 col-md-7 col-sm-7  my-sm-auto ms-sm-auto me-sm-0">
              <div class="nav-wrapper position-relative end-0">
                <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">


                  <li class="nav-item col-lg-7 col-md-7 col-sm-7  my-auto">
                           
                            <Multiselect
                             
                              v-model="janelas"
                              placeholder="Janelas"
                              mode="tags"
                              :close-on-select="false"
                              :searchable="true"
                              :create-option="true"
                                noOptionsText="Nenhuma opção disponível"
                                noResultsText="Nenhum resultado encontrado"
                                multipleLabel="Itens selecionados"
                                optionsLabel="Opções disponíveis"
                                selectLabel="Pressione Enter para selecionar"
                                deselectLabel="Pressione Enter para remover"
                                selectedLabel="Selecionado"
                              :options="[
                                  { value: '1', label: '08:00-10:00' },
                                  { value: '2', label: '10:00-12:00' },
                                  { value: '3', label: '12:00-14:00' },
                                  { value: '4', label: '14:00-16:00' },
                                  { value: '5', label: '16:00-18:00' },
                                  { value: '6', label: '18:00-20:00' },
                              ]"
                            />

                    </li> 

                  <li class="nav-item col-lg-4 col-md-4 col-sm-5  my-auto">
                    
                
            
                      <select v-model="id_operacao" @change="getRotasOperacao(id_operacao)" class="form-select form-select-lg" aria-label=".form-select-lg example">
                        <option v-for="item in operacoes" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </option>
                      </select>

                  </li>
                </ul>
                </div>
            </div>
            <div class="col-auto my-auto">
              <argon-button
                color="secondary"
                variant="gradient"
                @click="imprimirPagina()"
                class="ms-auto mb-0"
                >Imprimir</argon-button>

            </div>

          </div>
        </div>
      </div>
    </div>
  </nav>
  <div class="report-container">
    <div v-for="(rota, index) in rotasFiltradas" :key="index">

      <div v-if="index === 0" class="header_print row text-center">
        <div class="col-lg-2 col-md-2 col-2 d-flex align-items-center justify-content-center">
          <img src="/assets/img/logotipodelivery.webp" alt="Logo" class="logo img-fluid">
        </div>
        <div class="col-lg-8 col-md-8 col-8">
          <h1 class="report-title">PEDIDOS POR JANELA DE ENTREGA</h1>
          <h3 class="delivery-type">TIPO DE ENTREGA: <strong>7023</strong> - Receba em Casa</h3>
        </div>
        <div class="col-lg-2 col-md-2 col-2 text-center">
          <h2 class="store-text">LOJA</h2> 
          <span class="store-number">{{rota.id_operacao}}</span><br>
          <span class="store-date">{{currentDate}}</span>
        </div>
      </div>
      <div class="body_print">
        <div class="row text-start">
          <div class="col-md-12 txt-romaneio-id">
            <strong>ENTREGA:</strong>#{{rota.id}} {{rota.name}} 
          </div>
          <div class="col-md-12">
          <table>
            <thead>
              <tr>
                <th class="col-num">#</th>
                <th class="col-pedido">PEDIDO</th>
                <th class="col-cliente">CLIENTE / FONE</th>
                <th class="col-endereco">ENDEREÇO / NÚMERO / COMPLEMENTO</th>
                <th class="col-pagamento text-center">PAGAMENTO</th>
                <th class="col-caixas">CAIXAS</th>
                <th class="col-recebimento">RECEBIMENTO</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(order, index) in rota.Pedidos" :key="order.id">
                <td class="data-num" >{{ index + 1 }}</td>
                <td class="data-pedido">{{ order.numero_pedido }}</td>
                <td class="data-cliente"><strong>{{ order.nome_cliente }}</strong><br />{{ order.telefone_cliente }}</td>
                <td class="data-endereco">{{ order.endereco1_cliente || "" + " " + order.endereco2_cliente || "" }}, {{  order.numero_cliente  }} - {{  order.bairro_cliente  }}, {{  order.cidade_cliente  }}/{{order.estado_cliente}}</td>
                <td>
                  <div class="text-center">
                    {{ order.pagamento_status=='paid' ? 'PAGO':'NÃO PAGO' }}<br>
                    {{ order.pagamento_status=='paid' ? 'ONLINE':'PAGA NA ENTREGA' }}
                  </div>
                </td>
                <td>
                  <div v-html="formatarEmbalagensPorTipo(order.embalagens)"></div>
                                

                </td>
                <td>

                  <div class="col-md-2 text-center">
                    <br>
                    <span class="text-nome">NOME/SOBRENOME:</span><br><br>
                    <span class="text-docs">RG/CPF</span><span class="text-docs-ass">ASS:</span><br><br>
                  </div>
                  

                </td>
              </tr>
            </tbody>
          </table>
          </div>
          </div>
      </div>
    </div>
  </div>
</template>



<style scoped>
.report-container {
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: auto;
  border: 1px solid #ccc;
  padding: 10px;
  background: #fff;
}

.report-container .txt-romaneio-id {
  color: #000;
}



.report-container .col-num {
  width: 2%;
}
.report-container .dat6a-num {
  text-align: center;
}
.report-container .col-pedido {
  width: 7%;
}

.report-container .data-pedido {
    font-weight: bold;
    font-size: 15px;
}

.report-container .col-cliente {
  width: 10%;
}
.report-container .data-cliente strong {
    font-weight: bold;
    font-size: 12px;
}
.report-container .col-endereco {
  width: 20%;
}
.report-container .data-endereco {
    font-size: 13px;
    font-family: sans-serif;
}

.report-container .col-pagamento {
  width: 5%;
}
.report-container .data-pagamento {
   font-size: 13px;
    font-family: sans-serif;
}
.report-container .col-caixas {
  width: 10%;
}
.report-container .col-recebimento {
  width: 20%;
}

.report-container h1 {
  font-size: 15px;  /* Reduzindo o tamanho do título */
  text-align: center;
}

.report-container h2 {
  font-size: 18px;
  text-align: center;
}


.report-container .text-nome {
  font-size: 1em;
  font-weight: 200;
  color: black;
}
.report-container .text-docs {
  font-size: 1em;
  font-weight: 200;
  color: black;
}

.report-container .text-docs-ass {
  margin-left: 150px;
  font-size: 1em;
  font-weight: 200;
  color: black;
}


.report-container h3 {
  font-size: 18px;
  text-align: center;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.report-container .logo img {
  height: 60px;
}

.report-container .report-title {
  text-align: center;
}

.report-container .store-info {
  text-align: right;
}



.report-container .rota {
  text-align: right;
}
.report-container .store-text {
  font-size: 1em;
  font-weight: bold;
  color: black;
}
.report-container .store-number {
    font-size: 2em;
    font-weight: bold;
    line-height: 1;
    color: black;
    border: 1px solid black;
    padding-left: 50px;
    padding-right: 50px;
}

.report-container .store-date {
  font-size: 10px;
  font-weight: bold;
  color: black;
}


.report-container .text-muted {
  font-size: 2em;
  font-weight: bold;
  color: black;
}

.report-container  tr{


  border-bottom: 1px solid rgb(85, 85, 85);
}

table {
  width: 100%;
  border-collapse: collapse;
  line-height: 1;
  color: #000;
}

th {
  text-align: left;
  font-size: 10px;
}

td {
  font-size: 10px;
}


th {
  background: #ddd;
  font-weight: bold;
}




</style>

<script>

import { defineComponent, ref } from 'vue';

import Loading from "./Loading.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Multiselect from '@vueform/multiselect'

import moment from 'moment';

export default defineComponent({
  name: "romaneio-relatorio",
  components: {
    Loading,
    ArgonButton,
    Multiselect
  },
  props: {
      rotas: {
        type: Array,
        default: () => {
          [];
        },
      },
      operacoes: {
        type: Array,
        default: () => {
          [];
        },
      },
      doUpdate: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      getRotasOperacao: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
  },
  data() {
    return {
      currentDate: moment().format("DD/MM/YYYY - HH:mm:ss"),
      janelas: [  "1",  "2",  "3",  "4",  "5",  "6" ],      
    };
  },
  async mounted() {
    
    
  },
    computed: {
    rotasFiltradas() {
      return this.rotas.filter(rota => {

        const janelas_nome = [
          { value: '1', label: '08:00-10:00' },
          { value: '2', label: '10:00-12:00' },
          { value: '3', label: '12:00-14:00' },
          { value: '4', label: '14:00-16:00' },
          { value: '5', label: '16:00-18:00' },
          { value: '6', label: '18:00-20:00' },
        ];

        const intervalo = this.getIntervalo(rota); // exemplo: "08:00-10:00"
        if (!intervalo) return false;

        // acha qual item das janelas tem esse intervalo
        const janelaEncontrada = janelas_nome.find(j => j.label === intervalo);
        if (!janelaEncontrada) return false;

        // verifica se o usuário selecionou essa janela
        return this.janelas.includes(janelaEncontrada.value);
      });
    }
  },
  methods: {
    getIntervalo(rota) {
      const match = rota.name.match(/\[(.*?)\]/);
      if (!match) return null;
      return match[1].replace("–", "-"); // troca traço especial por "-"
    },
    imprimirPagina(embalagens) {

      window.print();
      
    },
    formatarEmbalagensPorTipo(embalagens) {
      const agrupado = {};

      // Itera sobre as embalagens
      embalagens.forEach(embalagem => {

        if(embalagem.unidadetransporte){;

          const tipo = embalagem.unidadetransporte.tipo.toUpperCase(); // "SECA" ou "FRIA"
          const codigo = embalagem.codigo_embalagem;

          // Verifica se o tipo já existe no objeto de agrupamento
          if (agrupado[tipo]) {
            agrupado[tipo].push(codigo);
          } else {
            agrupado[tipo] = [codigo];
          }
        }
      });

      // Formata a resposta no formato desejado
      const resultado = [];
      for (const tipo in agrupado) {
        resultado.push(`${tipo}:${agrupado[tipo].join(',')}`);
      }

      return resultado.join('<br>');
    },

   },
});
</script>

